import { useMemo } from 'react'
import { CountryPreferenceProduct } from '@/api/Clients/Types/CountryPreferenceProduct'
import {
  getProductPickerGroups,
  getSelectedProductPickerValues,
  mapSelectedProducts,
} from '@/api/Clients/Types/TickmillProductDto'
import { FormMultiSelectField } from '@/components/Form/FormField'

interface CountryProductsFieldProps {
  availableProducts: CountryPreferenceProduct[]
  products: CountryPreferenceProduct[]
  onChange(products: CountryPreferenceProduct[]): void
  className?: string
  error?: string | string[]
  label?: string
}

const normalizePickerValues = (
  value: string[] | number[] | string | number | null | undefined
): string[] => {
  if (Array.isArray(value)) return value.map(String)
  return value === null || value === undefined || value === '' ? [] : [String(value)]
}

export const CountryProductsField = ({
  availableProducts,
  products,
  onChange,
  className,
  error,
  label = 'Products',
}: CountryProductsFieldProps) => {
  const options = useMemo(
    () =>
      getProductPickerGroups(availableProducts).map((group) => ({
        label: group.label,
        options: group.options.map((option) => ({
          id: option.value,
          name: option.label,
        })),
      })),
    [availableProducts]
  )

  return (
    <FormMultiSelectField
      className={className}
      label={label}
      options={options}
      error={error}
      placeholder='Select products'
      showSearch
      value={getSelectedProductPickerValues(products)}
      onChange={(selectedValues) =>
        onChange(
          mapSelectedProducts(normalizePickerValues(selectedValues), availableProducts, products)
        )
      }
    />
  )
}
